// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as RadioIndicator$OrcaPaymentPage from "./RadioIndicator.bs.js";
import * as InstallmentPlanDetails$OrcaPaymentPage from "./InstallmentPlanDetails.bs.js";

function InstallmentOptionItem(props) {
  var onSelect = props.onSelect;
  var isSelected = props.isSelected;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  return React.createElement("div", {
              className: "relative flex items-center gap-2 w-full " + (
                props.isLastItem ? "" : "border-b"
              ) + " cursor-pointer",
              style: {
                backgroundColor: themeObj.colorBackground,
                borderColor: themeObj.borderColor,
                padding: "calc(" + themeObj.spacingUnit + " * 0.8) " + themeObj.spacingUnit
              },
              onClick: (function (param) {
                  onSelect();
                })
            }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: isSelected,
                  children: React.createElement("div", {
                        className: "absolute inset-0 opacity-[0.06] pointer-events-none",
                        style: {
                          backgroundColor: themeObj.colorPrimary
                        }
                      })
                }), React.createElement(RadioIndicator$OrcaPaymentPage.make, {
                  isSelected: isSelected
                }), React.createElement(InstallmentPlanDetails$OrcaPaymentPage.make, {
                  plan: props.plan,
                  currency: props.currency
                }));
}

var make = InstallmentOptionItem;

export {
  make ,
}
/* react Not a pure module */
